export const isWorkPermit = (value: string): boolean =>
  value.includes('work_permits.')
